<template>
  <v-app id="app" class="green darken-3">
    <template v-if="logueado">
      <v-app-bar
        :clipped-left="$vuetify.breakpoint.lgAndUp"
        app
        color="grey lighten-3"
      >
        <v-toolbar-title
          style="max-width: 201px; min-width: 100px; width: 201px"
          align="center"
          class="text-uppercase mt-2"
        >
          <img alt="Logo" :src="imagen" style="width: 130px; height: 60px" />
        </v-toolbar-title>
        <v-app-bar-nav-icon @click.stop="drawer = !drawer" x-large />
        <v-spacer></v-spacer>
        <v-menu
          v-model="menu"
          :close-on-content-click="false"
          :nudge-width="100"
          offset-x
        >
          <template v-slot:activator="{ on }">
            <v-btn depressed color="grey lighten-3" v-on="on">
              <Avatar style="padding-bottom: 20px"></Avatar>
            </v-btn>
          </template>

          <v-card>
            <v-list>
              <v-list-item>
                <v-flex>
                  <Avatar></Avatar>
                  <v-layout column align-center>
                    <v-list-item-title style="text-align: center">{{
                      nombre
                    }}</v-list-item-title>
                  </v-layout>
                </v-flex>
              </v-list-item>
            </v-list>
            <v-list>
              <v-list-item v-if="profile" :to="{ name: 'myperfil' }">
                <v-icon color="green">person_pin</v-icon>
                <v-list-item-title>
                  <v-btn depressed color="white">Mi Perfil</v-btn>
                </v-list-item-title>
              </v-list-item>
              <v-list-item>
                <v-icon color="red">exit_to_app</v-icon>
                <v-list-item-title>
                  <v-btn depressed color="white" @click="salir()">Salir</v-btn>
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-card>
        </v-menu>
      </v-app-bar>
    </template>
    <template>
      <v-navigation-drawer
        v-model="drawer"
        v-if="logueado"
        :clipped="$vuetify.breakpoint.lgAndUp"
        app
      >
        <template v-if="logueado">
          <Sidebar></Sidebar>
        </template>
      </v-navigation-drawer>
    </template>
    <v-main>
      <router-view />
    </v-main>
    <Footer v-if="logueado"></Footer>
  </v-app>
</template>

<script>
import { Base64 } from 'js-base64';

import apiDocumentosService from './Services/apiDocumentosService';
import parametrosGeneralesService from './Services/parametrosGeneralesService';
import Avatar from '@/components/Avatar';
import Footer from '@/components/Footer';
import Sidebar from '@/components/Sidebar';
import { permisosPerfilMixin } from './mixins/Permisos/perfil/perfilMixin';

export default {
  name: 'App',
  components: {
    Footer,
    Sidebar,
    Avatar,
  },
  mixins: [permisosPerfilMixin],
  data() {
    return {
      menu: false,
      drawer: true,
      path: this.$route.name,
      _id: '',
    };
  },

  computed: {
    imagen() {
      return this.$store.state.logo || '';
    },

    profile() {
      return (
        this.$store.state.usuario &&
        this.permisosPerfil.accesoModulo
      );
    },

    nombre() {
      return this.$store.state.usuario.nombre;
    },
    logueado() {
      return (
        this.$store.state.usuario &&
        this.$store.state.token &&
        this.$route.name !== 'Login'
      );
    },
  },

  created() {
    this.$store.dispatch('autoLogin');
    this.$store.dispatch('autoTokenRol');
    this.$store.dispatch('autoTokenAPI');
    this.obtenerParametros();
  },

  methods: {
    async obtenerParametros() {
      this.limpiarLogo();

      try {
        await this.cargarParametrosPlataforma();
      } catch {
        this.limpiarLogo();
      }
    },

    limpiarLogo() {
      localStorage.removeItem('logo');
      this.$store.commit('setLogo', '');
    },

    async cargarParametrosPlataforma() {
      const respuesta =
        await parametrosGeneralesService.obtenerParametrizacionInicial();
      const infoBasica = Array.isArray(respuesta) ? respuesta[0] : respuesta;

      if (infoBasica) {
        await this.guardarLogoApi(infoBasica.urlLogo);
      }

      const color = infoBasica?.color || 'primary';
      this.$store.commit('setColorFooter', color);

      const nombrePlataforma = infoBasica?.nombrePlataforma || '';
      this.$store.commit('setNombrePlataforma', nombrePlataforma);
    },

    async guardarLogoApi(urlLogo) {
      if (!urlLogo) {
        return;
      }

      const logo = await apiDocumentosService.obtenerLogoAbierto(urlLogo);
      localStorage.setItem('logo', Base64.encode(logo));
      this.$store.commit('setLogo', logo);
    },

    salir() {
      this.$store.dispatch('salir');
    },
  },
};
</script>
